import { RiArrowRightSLine } from "react-icons/ri";
import { UseCaseIcon } from "./UseCaseIcon";
import { UseCase } from "@pages/resources/free-whatsapp-message-templates/index";
import { industryColorData, useCasesData } from "types/wa-message-templates";

interface IndustryGridProps {
    useCase: string;
    industry: string;
    useCases: UseCase[];
}
const IndustryGrid: React.FC<IndustryGridProps> = ({ useCase, industry, useCases }) => {
    const findTemplateLink = (industry: string, use_case: string) => {
        const match = useCases.find((item) => item.industry === industry && item.use_case === use_case);
        return match ? match.template_link : "#"; // Return the template link or null if not found
    };
    return (
        <div className="max-w-6xl mx-auto flex flex-col justify-between items-center gap-14">
            <div className="flex flex-col items-center mx-6 lg:mx-40 gap-4 mt-12">
                <h2 className="text-4xl font-semibold text-gray-900 text-center w-fit">
                    Here are examples for a few other <span className="whitespace-nowrap">{industry}</span> business applications
                </h2>
                <p className="text-base font-normal text-center  lg:mx-4 px-2 text-gray-700">
                    Access a collection of tailored message templates designed for <span className="whitespace-nowrap">{industry}</span> customers for effective communication
                </p>
            </div>
            <div className="flex flex-wrap justify-center items-center mb-20 gap-2 lg:gap-8">
                {useCasesData.map((item) => {
                    return item !== useCase ? (
                        <a
                            href={findTemplateLink(industry, item)}
                            className="flex flex-col bg-white rounded-lg overflow-hidden border-2 border-solid border-gray-100 w-44 lg:w-48 lg:h-56 h-52 cursor-pointer hover:shadow-lg hover:no-underline mb-4"
                        >
                            <div className="flex flex-col items-center gap-1 bg-yellow-100  h-full" style={{ background: industryColorData[industry]["usecase-color"] }}>
                                <div className="bg-white mt-4 mb-2 rounded-md p-2 shadow-md w-16 h-16 flex items-center justify-center">
                                    <UseCaseIcon strokeColor={industryColorData[industry]["stroke-color"]} usecase={item} />
                                </div>
                                <p className="font-semibold text-center text-lg text-gray-700 mx-3 lg:p-2">{item}</p>
                            </div>
                            <div className="flex p-3 justify-center items-center bg-white">
                                <a className="flex underline font-medium text-blue-500 text-base" data-cy={`usecase-${item}-view_template_link`}>
                                    View templates
                                </a>
                                <RiArrowRightSLine className="text-blue-500" size={20} />
                            </div>
                        </a>
                    ) : null;
                })}
            </div>
        </div>
    );
};

export default IndustryGrid;
